<h2 mat-dialog-title>Éditer l'IBAN</h2>

<mat-dialog-content>
  <div class="flex gap-3 items-end mt-4 py-2">
    <!-- Pays -->
    <mat-form-field appearance="outline" class="w-24">
      <mat-label>Pays</mat-label>
      <input
        #paysInput
        matInput
        type="text"
        [(ngModel)]="data.pays"
        mask="AAAA"
        [showMaskTyped]="true"
        placeHolderCharacter="_"
        (ngModelChange)="onFieldChange('pays', banqueInput)"
        (keydown)="onKeyDown($event, null, banqueInput)"
        class="font-mono uppercase text-center"
      />
    </mat-form-field>

    <!-- Banque -->
    <mat-form-field appearance="outline" class="w-28">
      <mat-label>Banque</mat-label>
      <input
        #banqueInput
        matInput
        type="text"
        [(ngModel)]="data.banque"
        mask="AAAAA"
        [showMaskTyped]="true"
        placeHolderCharacter="_"
        (ngModelChange)="onFieldChange('banque', guichetInput)"
        (keydown)="onKeyDown($event, paysInput, guichetInput)"
        class="font-mono uppercase text-center"
      />
    </mat-form-field>

    <!-- Guichet -->
    <mat-form-field appearance="outline" class="w-28">
      <mat-label>Guichet</mat-label>
      <input
        #guichetInput
        matInput
        type="text"
        [(ngModel)]="data.guichet"
        mask="AAAAA"
        [showMaskTyped]="true"
        placeHolderCharacter="_"
        (ngModelChange)="onFieldChange('guichet', compteInput)"
        (keydown)="onKeyDown($event, banqueInput, compteInput)"
        class="font-mono uppercase text-center"
      />
    </mat-form-field>

    <!-- Compte -->
    <mat-form-field appearance="outline" class="w-40">
      <mat-label>Compte</mat-label>
      <input
        #compteInput
        matInput
        type="text"
        [(ngModel)]="data.compte"
        mask="AAAAAAAAAAA"
        [showMaskTyped]="true"
        placeHolderCharacter="_"
        (ngModelChange)="onFieldChange('compte', cleInput)"
        (keydown)="onKeyDown($event, guichetInput, cleInput)"
        class="font-mono uppercase text-center"
      />
    </mat-form-field>

    <!-- Clé -->
    <mat-form-field appearance="outline" class="w-20">
      <mat-label>Clé</mat-label>
      <input
        #cleInput
        matInput
        type="text"
        [(ngModel)]="data.cle"
        mask="AA"
        [showMaskTyped]="true"
        placeHolderCharacter="_"
        (ngModelChange)="onFieldChange('cle', null)"
        (keydown)="onKeyDown($event, compteInput, null)"
        class="font-mono uppercase text-center"
      />
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Annuler</button>
  <button mat-raised-button color="primary" (click)="save()">
    Enregistrer
  </button>
</mat-dialog-actions>
